export default "/images/arrow-right-circle.svg?5cd2852ae89eae76d5f95b1f5cb3c52c";